import Image from 'next/legacy/image'
import clsx from 'clsx'

import Text from '~/components/Text/Text'
import Icon from '~/components/Icon/Icon'
import Link from '~/components/Link/Link'
import { makeTrackAttr } from '~/lib/ga-events'

import { useTeam } from './useTeam'
import styles from './AboutTeam.module.sass'

const AboutTeam: React.FC = () => {
  const teamMembers = useTeam()

  return (
    <div className={clsx('site-grid site-container', styles.section)}>
      <div
        className={clsx('col-span-full md:col-start-2 md:col-end-8 lg:col-start-4 lg:col-end-10', styles.textSection)}
      >
        <Text variant='subheading' fontSize={[28, 28, 40]}>
          Team
        </Text>
        <div>
          <Image src='/Images/team.jpeg' width={1280} height={787} alt='Team Zoom' />
        </div>
      </div>
      <div
        className={clsx(
          'col-span-full grid grid-cols-1 gap-x-[16px] gap-y-[48px]',
          'md:col-start-2 md:col-end-8 md:grid-cols-1',
          'lg:place-items-center lg:col-start-4 lg:col-end-10 lg:gap-x-[unset] lg:gap-y-[80px]'
        )}
      >
        {teamMembers.map(({ photoSrc, name, title, socialLinks }) => (
          <div key={title} className={styles.personTile}>
            {photoSrc && <Image src={photoSrc} width='800' height='800' layout='responsive' className={styles.personPhoto} />}
            <Text fontSize={[18, 14, 18]} className={styles.personName}>
              {name}
            </Text>
            <Text fontSize={[18, 14, 18]} className={styles.personTitle}>
              {title}
            </Text>
            <ul className={styles.socialLinks}>
              {socialLinks.map(({ icon, link }) => (
                <li key={link}>
                  <Link
                    href={link}
                    className={styles.socialLink}
                    data-track={`social:go-to-employee-profile:${makeTrackAttr(link)}`}
                  >
                    <Icon name={icon} className={styles.socialIcon} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AboutTeam
